import { getDatetimeText } from '@back-office/ui';
import { DateRange } from '@material-ui/pickers';
import { useLocalStore } from 'mobx-react';
import qs from 'query-string';
import { MouseEvent } from 'react';
import { Store } from '.';
import useInject from '../../../hooks/useInject';

type UseViewModelReturn = {
  state: Store;
};

const useViewModel = (handleOnClose: () => void): UseViewModelReturn => {
  const { getRecurringEnrollmentReport, auth } = useInject((root) => root);

  const state = useLocalStore<Store>(() => ({
    date: [null, null],
    openCalendar: false,
    handleOnChangeDatePicker(date: DateRange<Date>) {
      this.date = date;
    },
    handleOnClear(event: MouseEvent<HTMLOrSVGElement>) {
      event.stopPropagation();
      this.openCalendar = false;
      this.date = [null, null];
      handleOnClose();
    },
    handleOnClickDatePicker() {
      this.date = [null, null];
      this.openCalendar = true;
    },
    handleOnCloseDatePicker() {
      if (this.date[0] && this.date[1]) {
        this.openCalendar = false;
      }
    },
    handleClose(event: MouseEvent<HTMLOrSVGElement>, reason: string) {
      if (reason === 'backdropClick') {
        this.openCalendar = false;
        state.handleOnClear(event);
      }
    },
    async handleOnExport() {
      if (this.date[0] && this.date[1]) {
        const query = qs.stringify({
          merchantID: auth.currentUser.merchantID,
          enrollment_date_from: this.date[0]
            ? getDatetimeText(this.date[0], 'western')
            : null,
          enrollment_date_to: this.date[1]
            ? getDatetimeText(this.date[1], 'western')
            : null,
        });
        await getRecurringEnrollmentReport(query).finally(() =>
          handleOnClose()
        );
      }
      this.date = [null, null];
    },
  }));

  return {
    state,
  };
};

export default useViewModel;
